import api from './api';
import _ from 'lodash';

export default {
  getCustomerEnquiries(id) {
    return new Promise((resolve, reject) => {
      api
        .get('enquiry', {
          params: {
            includes: 'product.business',
            orderBy: 'created_at,desc',
            filters: {
              where: [['business_id', '=', id]]
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  get(id, fields) {
    return new Promise((resolve, reject) => {
      let params = {
        fields
      };
      api
        .get('enquiry/find/' + id, { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getPaginatedEnquiries(page, pageSize, orderby, terms, ranges, dates, fields, filters, search) {
    fields = { ...fields };

    let params = {
      paginate: pageSize,
      page,
      orderby,
      terms,
      ranges,
      dates,
      fields,
      filters,
      search
    };

    return new Promise((resolve, reject) => {
      api
        .get('enquiry/search', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getEnquiryStatusList() {
    return new Promise((resolve, reject) => {
      api
        .get('enquiry-status')
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateCustomerEnquiry(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`enquiry/${id}`, updates)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  duplicateCustomerEnquiry(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .post(`enquiry/${id}/duplicate`, updates)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  makeEnquiry(business, product) {
    const requestParams = {
      business_id: business.id,
      funding_requested: business.funding,
      product_id: product.id,
      colour: product.colour
    };

    return new Promise((resolve, reject) => {
      api
        .post('enquiry', requestParams)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  reSendEnquiry(enquiryId) {
    return new Promise((resolve, reject) => {
      api
        .put(`enquiry/${enquiryId}/resend`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getEnquiryCalculatedFee(enquiry) {
    const fundingRequested = _.parseInt(_.replace(_.replace(enquiry.funding_requested, ',', ''), '£', ''));
    const fundingOffered = _.parseInt(_.replace(_.replace(enquiry.funding_offered, ',', ''), '£', ''));
    const fundingObtained = _.parseInt(_.replace(_.replace(enquiry.funding_obtained, ',', ''), '£', ''));
    const fundingForCalculation = fundingObtained || fundingOffered || fundingRequested;

    return new Promise((resolve, reject) => {
      api
        .get(`enquiry/${enquiry.id}/calculated-fee`, {
          params: {
            funding_amount: fundingForCalculation,
            fee_structure: enquiry.bbb_fee_type
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
